var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.uiFlags.isFetching
      ? _c("div", { staticClass: "info section_gap_x" }, [
          _c("div", [
            _c("div", { staticClass: "logo_wrapper" }, [
              _c("div"),
              _vm._v(" "),
              _c(
                "div",
                [_c("SHImageVue", { attrs: { src: _vm.merchant.logo_url } })],
                1
              ),
              _vm._v(" "),
              _c("div")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "shop_label" }, [
              _vm._v(_vm._s(_vm.merchant.name))
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.merchant.description))]),
            _vm._v(" "),
            _vm.merchant.address
              ? _c("div", { staticClass: "description px_md py_md" }, [
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.merchant.address.line1) +
                        ",\n          " +
                        _vm._s(_vm.merchant.address.line2) +
                        ",\n          " +
                        _vm._s(_vm.merchant.address.postcode) +
                        ",\n          " +
                        _vm._s(_vm.merchant.address.city) +
                        ",\n          " +
                        _vm._s(_vm.merchant.address.state) +
                        "\n        "
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "py_md" }, [
            _c("p", { staticClass: "shop_label" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("MERCHANT.INFO.PHONE_LABEL")) +
                  "\n        "
              ),
              _c(
                "a",
                {
                  staticStyle: { "font-weight": "400" },
                  attrs: { href: "tel:" + _vm.merchant.phone }
                },
                [_vm._v(_vm._s(_vm.merchant.phone))]
              )
            ]),
            _vm._v(" "),
            !_vm.merchant.delivery
              ? _c("div", { staticClass: "current_queue" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("MERCHANT.INFO.QUEQE_LABEL")) + ": ")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.merchant.order_queue_count || 0))])
                ])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "item_categories section_gap_x",
        attrs: { id: "item_categories" }
      },
      _vm._l(_vm.allCatalogItems, function(category, idx) {
        return _c(
          "button",
          {
            key: category.id,
            class: _vm.isActiveCategory(category) ? "active" : "",
            on: {
              click: function($event) {
                return _vm.onCategorySingleSelect(idx)
              }
            }
          },
          [_vm._v(_vm._s(category.category))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        ref: "catalogDisplayContainer",
        staticClass: "section_gap_x section_gap_y",
        attrs: { id: "catalogDisplayContainer" }
      },
      [
        _c("div", { ref: "topSkeleton" }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "categories" },
          _vm._l(_vm.flattenedDisplayCatalogItems, function(catalog) {
            return _c(
              "li",
              {
                key: catalog.id,
                ref: _vm.getCatalogRef(catalog),
                refInFor: true,
                staticClass: "category_card",
                class: {
                  last_category_card: catalog.isLastItemOfCatagory
                },
                attrs: {
                  id:
                    "catalog_container-" +
                    (catalog.isFirstItemOfCatagory && catalog.categoryId),
                  "data-category-id": catalog.categoryId,
                  "data-catalogItem-id": catalog.id
                },
                on: {
                  click: function($event) {
                    return _vm.goToProduct(catalog.id)
                  }
                }
              },
              [
                _c("SHImageVue", {
                  attrs: { className: "card_img", src: catalog.image_link }
                }),
                _vm._v(" "),
                _c("h4", { staticClass: "shop_label title" }, [
                  _vm._v(_vm._s(catalog.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "footer" }, [
                  _c("span", [_vm._v(_vm._s(catalog.price))]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "icon" },
                    [_c("fluent-icon", { attrs: { icon: "cart" } })],
                    1
                  )
                ])
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { ref: "bottomSkeleton" }),
        _vm._v(" "),
        _vm.uiFlagsCatalog.isCatalogItemFetching ||
        _vm.uiFlags.isFetching ||
        _vm.isCatelogueItemsFetching
          ? _c("loader-round")
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }